<template>
    <tbody> 
        <!-- <tr v-if="account.account_type == 'group'" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }}</td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
        </tr>
        <tr v-else :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }} [{{ account.code }}]</td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }}</td>
            <td class="text-right">{{ Number(account.opening_balance).toFixed(2) }}</td>
            <td class="text-right">{{ Number(account.debit).toFixed(2) }}</td>
            <td class="text-right">{{ Number(account.credit).toFixed(2) }}</td>
            <td class="text-right">{{ Number(account.balance).toFixed(2) }}</td>
        </tr> -->

        <tr v-if="zero_active && sumvalue(account) == false" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'"> {{ account.name }} [{{ account.code }}] </td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">  {{ account.name }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.opening_balance, 2) }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.debit, 2) }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.credit, 2) }}</td>
            <td class="text-right" style="text-align: right;">{{ formatNumberWithDecimals(account.balance, 2) }}</td>
        </tr>

        <tr v-else-if="sumvalue(account)" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }} [{{ account.code }}] </td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">  {{ account.name }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.opening_balance, 2) }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.debit, 2) }}</td>
            <td class="text-right">{{ formatNumberWithDecimals(account.credit, 2) }}</td>
            <td class="text-right" style="text-align: right;">{{ formatNumberWithDecimals(account.balance, 2) }}</td>
        </tr>
    </tbody>               
    <AccountTrialBalance v-if="hasChildren" v-for="(child, c) in account.children" :key="c" :account="child" :level="(level + 1)" :spaces="(spaces + 15)" :code_active="showCode" :zero_active="showZeroRow"></AccountTrialBalance>
</template>

<script>

    export default {
        name: 'AccountTrialBalance',
        emit:['add-child', 'edit-item', 'delete-item'],
        props: {
            account: {
                type: Object,
                required: true,
            },
            level: {
                type: Number,
                default: 0,
            },
            spaces: {
                type: Number,
                default: 0,
            },
            code_active: {
                type: Boolean,
                default: false,
            },
            zero_active: {
                type: Boolean,
                default: false,
            }

        },
        data() {
            return {
                showChildren: true,
            }
        },
        computed: {
            accountLevel() {
                return this.level;
            },

            nodeMargin() {
                return 'padding-left: '+`${this.spaces}px;`;
            },

            hasChildren() {
                const { children } = this.account;
                return children && children.length > 0
            },

            toggleChildrenIcon() {
                return this.showChildren ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-left';
            },
            showCode() {
                if(this.code_active) {
                    return true;
                }else{
                    return false;
                }
            },
            showZeroRow() {
                if(this.zero_active) {
                    return true;
                }else{
                    return false;
                }
            }

            
        },
        methods: {
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },
            
            sumvalue(account){
                let opening = Number(parseFloat(account.opening_balance ?? 0)).toFixed(3);
                let debit = Number(parseFloat(account.debit ?? 0)).toFixed(3);
                let credit = Number(parseFloat(account.credit ?? 0)).toFixed(3);
                let balance = Number(parseFloat(account.balance ?? 0)).toFixed(3);
                if(
                    (opening == '0.000' || opening == '-0.000') &&
                    (debit == '0.000' || debit == '-0.000') &&
                    (credit == '0.000' || credit == '-0.000') &&
                    (balance == '0.000' || balance == '-0.000')
                ) {
                    return false;
                }else{
                    return true;
                }

                // return true;
            }
        }
    }

</script>